import { AboutModalContentOrMobileFooter } from '../../components/about-modal-content-or-mobile-footer';
import { StandaloneModal } from '../standalone-modal';

interface Props {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onContactLinkPress: () => void;
}

export const AboutUprightModal = ({ isOpen, setIsOpen, onContactLinkPress }: Props) => {
  return (
    <StandaloneModal
      modalName="About Upright"
      isOpen={isOpen}
      closeModal={() => {
        setIsOpen(false);
      }}
    >
      <AboutModalContentOrMobileFooter onContactLinkPress={onContactLinkPress} />
    </StandaloneModal>
  );
};
